import { PaymentPackageItem } from "shared/api/services";
import { IExportedPackage } from "../types";

export const mapPaymentPackageToExportedPackage = (
  item: PaymentPackageItem,
): IExportedPackage => ({
  id: item.consecutive,
  paymentConsecutive: item.consecutive,
  nit: item.employerIdNumber,
  healthProvider: item.providerName,
  invoicesCount: item.invoiceCount,
  totalExportValue: item.totalValue,
  exportStatus: item.statePackage.name,
  statePackage: item.statePackage,
  exportDate: item.createdAt,
  exportUser: item.createdBy,
  electronicDocumentIds: item.electronicDocumentIds,
});
